<template>
  <div class="book">
    <h1>This is the book an appointment page</h1>
    <br /><br />
    <img alt="Vue logo" src="../assets/logo.png" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Book",

  mounted() {
    window.triggerResize();
  }
};
</script>
